import { render, staticRenderFns } from "./AccidentReportIndex.vue?vue&type=template&id=c8f1c15c&scoped=true&"
import script from "./AccidentReportIndex.vue?vue&type=script&lang=js&"
export * from "./AccidentReportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f1c15c",
  null
  
)

export default component.exports